import React, { useState, useEffect } from 'react';
import '../src/Navigation.css' 

function Navigation() {
  const [showMenu, setShowMenu] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    // Initialize the isSmallScreen state and add a resize event listener
    handleResize();
    window.addEventListener('resize', handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <nav>
      <div className="company-name">MarketServe by CloudServe Systems Pvt. Ltd</div>
      {isSmallScreen && (
        <button className="menu-toggle" onClick={toggleMenu}>
          ☰
        </button>
      )}
      <ul className={`nav-list ${isSmallScreen && showMenu ? 'active' : ''}`}>
        <li>
          <a href="/home">Home</a>
        </li>
       
       
       
        <li>
          <a href="https://marketserve-tool.cloudservesystems.com/signup/" target='_blank'>Sign Up</a>
        </li>
      </ul>
    </nav>
  );
}

export default Navigation;
